<template>
    <div>
        <v-offline online-class="online" offline-class="offline" @detected-condition="amIOnline">
            <template v-slot:[onlineSlot] :slot-name="onlineSlot">
                {{ onlineOfflineMsg }}
            </template>
            <template v-slot:[offlineSlot] :slot-name="offlineSlot">
                {{ onlineOfflineMsg }}
            </template>
        </v-offline>
        <div class="row setMarginTop">
            <div class="col">
                <div class="panel-heading">
                    <h5>Records > {{ isReadonly ? 'View Record' : 'Edit Record' }}</h5>
                    <hr>
                </div>
            </div>
        </div>
        <div class="hc-edit-records row px-3">
            <el-form class="col" ref="recordForm" :model="selectedRecord">
                <div class="row">
                    <div class="col-lg-2">
                        <div v-if="!selectedRecord.image_url" class="image-placeholder">
                            Loading image…
                        </div>

                        <el-image
                            v-else
                            style="width: 100px; height: 100px"
                            :src="selectedRecord.image_url"
                            fit="cover"
                            >
                            <div slot="placeholder">Loading image…</div>
                        </el-image>
                    </div>
                    <div class="col-lg-2">
                        <el-form-item label="Collar Id" prop="collar_id">
                            <el-input placeholder="" v-model="selectedRecord.collar_id"></el-input>
                        </el-form-item>
                    </div>
                    <div class="col-lg-2">
                        <el-form-item label="Species" prop="species">
                            <el-input placeholder="" v-model="selectedRecord.species"></el-input>
                        </el-form-item>
                    </div>
                    <div class="col-lg-2">
                        <el-form-item label="Gender" prop="gender">
                            <el-select v-model="selectedRecord.gender" placeholder="Select">
                                <el-option label="Male" value="Male"></el-option>
                                <el-option label="Female" value="Female"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="col-lg-2">
                        <el-form-item label="Age" prop="age_category">
                            <el-input placeholder="" v-model="selectedRecord.age_category"></el-input>
                        </el-form-item>
                    </div>
                    <div class="col-lg-2">
                        <el-form-item label="Animal Name" prop="animal_name">
                            <el-input placeholder="" v-model="selectedRecord.animal_name"></el-input>
                        </el-form-item>
                    </div>
                    <div class="col-lg-2">
                        <el-form-item label="Ownership" prop="ownership">
                            <el-select v-model="selectedRecord.ownership" placeholder="Select">
                                <el-option v-for="ownership in ownerships" :key="ownership" :label="ownership"
                                    :value="ownership">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="col-lg-2">
                        <el-form-item label="Sterilized" prop="sterilized">
                            <el-select v-model="selectedRecord.sterilized" placeholder="Select">
                                <el-option label="Already Sterilized" value="Already Sterilized"></el-option>
                                <el-option label="Unsterilized" value="Unsterilized"></el-option>
                                <el-option label="Unknown" value="Unknown"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="col-lg-2">
                        <el-form-item label="Vaccination Given" prop="vaccination_other">
                            <el-select v-model="selectedRecord.given_vaccination_drug_ids" multiple
                                placeholder="Select">
                                <el-option v-for="pv in projectVaccineDrugs" :key="pv.id"
                                    :label="pv.vaccination_drug_name" :value="pv.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="col-lg-2">
                        <el-form-item label="Vaccination Other" prop="vaccination_other">
                            <el-input placeholder="" v-model="selectedRecord.vaccination_other"></el-input>
                        </el-form-item>
                    </div>
                    <div class="col-lg-2">
                        <el-form-item label="Deworming Done" prop="deworming">
                            <el-select v-model="selectedRecord.given_deworming_ids" multiple placeholder="Select">
                                <el-option v-for="pd in projectDewormings" :key="pd.id" :label="pd.deworming_name"
                                    :value="pd.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="col-lg-2">
                        <el-form-item label="Treatments Done" prop="treatment">
                            <el-select v-model="selectedRecord.given_treatment_ids" multiple placeholder="Select">
                                <el-option v-for="pt in projectTreatments" :key="pt.id" :label="pt.treatment_name"
                                    :value="pt.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="col-lg-2">
                        <el-form-item label="Notes" prop="notes">
                            <el-input type="textarea" :rows="2" v-model="selectedRecord.notes"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <template v-if="!isReadOnly">
                    <h6 class="border-top pt-3">Owner Details</h6>
                    <div class="row pt-2">
                        <div class="col-lg-2">
                            <el-form-item label="Owner Name" prop="owner_name">
                                <el-input placeholder="" v-model="selectedRecord.owner_name"></el-input>
                            </el-form-item>
                        </div>
                        <div class="col-lg-2">
                            <el-form-item label="Owner Mobile" prop="owner_mobile">
                                <el-input placeholder="" v-model="selectedRecord.owner_mobile"></el-input>
                            </el-form-item>
                        </div>
                        <div class="col-lg-2">
                            <el-form-item label="Owner Locality" prop="owner_locality">
                                <el-input placeholder="" v-model="selectedRecord.owner_locality"></el-input>
                            </el-form-item>
                        </div>
                        <div class="col-lg-3">
                            <el-form-item label="Owner Address" prop="owner_address">
                                <el-input type="textarea" :rows="2" v-model="selectedRecord.owner_address"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                </template>
                <div  class="float-right d-flex">
                    <el-button type="primary" plain @click="hideEditView">Cancel
                    </el-button>
                    <el-button v-if="!isReadOnly" type="success" @click="saveRecord">Save
                    </el-button>
                </div>
            </el-form>
        </div>
    </div>
</template>
<script>

import mixin from '../../../mixins/GlobalMixin';
import {
    Dialog,
    Button,
    Image,
    Form,
    FormItem,
    Input,
    Select,
} from "element-ui";
import VOffline from 'v-offline';
import healthClinicService from "../../../services/health-clinic.service";
export default {
    components: {
        [Dialog.name]: Dialog,
        [Button.name]: Button,
        [Image.name]: Image,
        [Form.name]: Form,
        [FormItem.name]: FormItem,
        [Input.name]: Input,
        [Select.name]: Select,
        VOffline
    },
    props: {
        recordId: {
            type: Number,
        },
    },
    data() {
        return {
            isReadOnly: false,
            project: null,
            records: [],
            selectedRecord: {
                id: null,
                rf_id: null,
                image_url: null,
                species: '',
                gender: '',
                animal_name: '',
                rf_id_location: '',
                name: '',
                ownership: '',
                age_category: '',
                collar_id: '',
                vaccination_other: '',
                deworming: '',
                treatment: '',
                notes: '',
                sterilized: '',
                owner_name: '',
                owner_mobile: '',
                owner_address: '',
                owner_locality: '',
                given_deworming_ids: '',
                given_treatment_ids: '',
                given_vaccination_drug_ids: ''
            },
            projectTreatments: [],
            projectDewormings: [],
            projectVaccineDrugs: [],
            ownerships: [
                "Owned",
                "Owned free roaming",
                "Community",
                "Community free roaming",
                "Stray",
                "Wild"
            ],
            table: null,
        }
    },
    mixins: [mixin],
    methods: {
        init() {
            const vm = this;
            vm.$store.dispatch("setScreenName", "Records");
            vm.setStaticData();
            vm.getRecord();
        },
        setStaticData() {
            const vm = this;
            vm.projectTreatments = vm.project.organisation.treatments;
            vm.projectDewormings = vm.project.organisation.dewormings;
            vm.projectVaccineDrugs = vm.project.organisation.vaccinations;
        },
        getRecord() {
            const vm = this;
            const loading = vm.$loading({
                lock: true,
                text: 'Loading record...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            healthClinicService.getRecordById(this.recordId)
                .then((apiResponse) => {
                    const record = apiResponse.response.data.hc_record_details;
                    const vm = this;
                    Object.assign(vm.selectedRecord, {
                        id: record.id,
                        rf_id: record.animal.rf_id,
                        image_url: record.image_url,
                        species: record.animal.species,
                        gender: record.animal.gender,
                        animal_name: record.animal.name,
                        rf_id_location: record.animal.rf_id_location,
                        name: record.animal.name,
                        ownership: record.ownership,
                        age_category: record.age_category,
                        collar_id: record.collar_id,
                        vaccination_other: record.vaccination_other,
                        deworming: record.deworming,
                        treatment: record.treatment,
                        notes: record.notes,
                        sterilized: record.sterilized,
                        owner_name: record.owner ? record.owner.name : null,
                        owner_mobile: record.owner ? record.owner.telephone_mobile : null,
                        owner_address: record.owner ? record.owner.google_street_address : null,
                        owner_locality: record.owner ? record.owner.google_locality : null,
                        given_deworming_ids: vm.parseNumericArray(record.given_deworming_ids),
                        given_treatment_ids: vm.parseNumericArray(record.given_treatment_ids),
                        given_vaccination_drug_ids: vm.parseNumericArray(record.given_vaccination_drug_ids)
                    });
                })
                .catch(error => {
                    vm.showAlert('Error', error.response.error.error_msg, false);
                })
                .finally(() => loading.close());
        },
        saveRecord() {
            const vm = this;
            const loading = vm.$loading({
                lock: true,
                text: 'Please wait updating record...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            healthClinicService.updateRecord(vm.projectId, vm.selectedRecord.id, vm.selectedRecord)
                .then((apiResponse) => {
                    apiResponse = apiResponse.response;
                    loading.close();
                    if (!apiResponse.error.error_code) {
                        vm.showAlert('Success', `Record updated successfully`, true);
                        vm.$router.push({ name: 'hcRecords' });
                    } else {
                        vm.showAlert('Error', apiResponse.error.msg, false);
                    }
                }).catch(error => {
                    loading.close();
                    vm.showAlert('Error', error.response.error.error_msg, false);
                });
        },
        hideEditView() {
            const vm = this;
            vm.$router.push({ name: 'hcRecords' });
        },
        parseNumericArray(input) {
            if (!input) return [];

            if (typeof input === 'string') {
                try {
                    const parsed = JSON.parse(input);
                    if (Array.isArray(parsed)) {
                        return parsed.map(Number);
                    }
                } catch {
                    return [];
                }
            }
            if (Array.isArray(input)) {
                return input.map(Number);
            }
            return [];
        }
    },
    mounted() {
        let vm = this;
        vm.project = vm.$store.getters.getCurrentSelectedProject;
        vm.isReadOnly = false
        vm.$store.getters.getUserRoleForCurrentProject.forEach(r => {
            if (r.role_name == 'VIEWER') {
                vm.isReadOnly = true
            }
        });
        vm.init();
    }
}

</script>
<style lang="scss">
.hc-edit-records {
    .el-form-item__label {
        padding: 0 !important;
        margin-bottom: 5px !important;
        line-height: 10px !important;
    }

    .save-btn {
        display: flex;
        align-content: center;
        align-items: center;
        justify-content: flex-end;
        position: absolute;
        right: 15px;
        bottom: 0;
    }
}
</style>
